import { tns } from '../../node_modules/tiny-slider/src/tiny-slider';
import { gsap } from 'gsap';
import { MotionPathPlugin } from 'gsap/MotionPathPlugin';
import hammer from 'hammerjs';

gsap.registerPlugin(MotionPathPlugin);

export default {
  init() {
    // JavaScript to be fired on team page
    console.log('team');
    let teamCards = Array.from(document.querySelectorAll('.team-card'));
    const teamFilters = document.querySelectorAll('.team-filter');
    const sliderClose = document.querySelector('.team-slider-close');
    let sliderControls = document.querySelector('.team-slider-controls');
    var sliderDirection = 'next';

    let activeTypes = ['team-card'];

    var teamCardSlider;
    var teamCardSliderOptions = {
      container: '.team-cards',
      items: 1,
      rewind: true,
      nav: false,
      mouseDrag: true,
      controlsContainer: '.team-slider-controls',
    };
    var teamActiveCardsIndexes = getActiveCardIndexes();

    let flip = new Flip();

    let row = 1;
    let index = 0;
    let nthChild = 0;

    teamCards.forEach((card) => {
      card.style.setProperty('--column', (index % 3) + 1);
      card.style.setProperty('--row', 3 * nthChild + 2 === index + 1 ? row + 1 : row);
      if (index % 3 === 2) {
        row += 2;
      }
      if (3 * nthChild + 2 === index + 1) {
        nthChild++;
      }
      index++;
    });

    if (window.innerWidth < 768) {
      teamCardSlider = tns(teamCardSliderOptions);
      addPanEventListenerToSlider();
      teamCards = Array.from(document.querySelectorAll('.team-card'));
      updateCardsZindex();
      teamCardSlider.events.on('indexChanged', handleIndexHasChanged);
    } else {
      addDashboardCardClickListener();
    }

    teamFilters.forEach((teamFilter) =>
      teamFilter.addEventListener('click', (e) => {
        const type = e.target.getAttribute('data-type');
        const isActive = e.target.getAttribute('aria-selected') === 'true';

        if (isActive && type !== 'team-card') {
          e.target.setAttribute('aria-selected', false);
          const typeIndex = activeTypes.indexOf(type);
          if (typeIndex > -1) {
            activeTypes.splice(typeIndex, 1);
          }
          if (activeTypes.length === 0) {
            activeTypes = ['team-card'];
            teamFilters[0].setAttribute('aria-selected', true);
          }
        } else if (type === 'team-card') {
          teamFilters.forEach((teamFilter) => teamFilter.setAttribute('aria-selected', false));
          e.target.setAttribute('aria-selected', true);
          activeTypes = ['team-card'];
        } else {
          e.target.setAttribute('aria-selected', true);
          teamFilters[0].setAttribute('aria-selected', false);
          const typeIndex = activeTypes.indexOf('team-card');
          if (typeIndex > -1) {
            activeTypes.splice(typeIndex, 1);
          }
          activeTypes.push(type);
        }

        teamActiveCardsIndexes = getActiveCardIndexes();
        const teamActiveCards = getActiveCards();
        const teamNotActiveCards = getNotActiveCards();

        flip.read(teamCards);
        updateTeamCardGridPositions();

        if (teamCardSlider && teamCardSlider.destroy) {
          gsap.to(teamNotActiveCards, {
            opacity: 0,
            xPercent: -10,
            duration: 0.2,
            stagger: 0.1,
            onComplete: function () {
              this.targets().map((target) => target.style.setProperty('visibility', 'hidden'));
            },
          });

          gsap.to(teamActiveCards, {
            visibility: 'visible',
            opacity: 1,
            xPercent: 0,
            stagger: 0.03,
            duration: 0.2,
          });

          const { index: currentIndex } = teamCardSlider.getInfo();
          const diffArr = teamActiveCardsIndexes.map((x) => Math.abs(currentIndex - x));
          const minNumber = Math.min(...diffArr);
          const nextIndex = teamActiveCardsIndexes[diffArr.indexOf(minNumber)];
          if (nextIndex !== currentIndex) {
            sliderDirection = getSliderDirection(teamActiveCards.length, nextIndex, currentIndex);
            teamCardSlider.goTo(nextIndex);
          }
        } else {
          flip.remove(teamNotActiveCards);
          flip.play(teamActiveCards);
        }
      }),
    );

    window.addEventListener('resize', function (e) {
      if (window.innerWidth >= 768) {
        if (teamCardSlider && teamCardSlider.destroy) {
          hideElement(sliderControls);
          teamCardSlider.destroy();
          teamCards = Array.from(document.querySelectorAll('.team-card'));
          hideElement(sliderClose);
          addDashboardCardClickListener();
          removeCarouselCardClickListener();
        }
      } else {
        if (teamCardSlider && teamCardSlider.destroy === null) {
          teamCardSlider = teamCardSlider.rebuild();
          teamCards = Array.from(document.querySelectorAll('.team-card'));
        } else if (!teamCardSlider) {
          teamCardSlider = tns(teamCardSliderOptions);
          teamCards = Array.from(document.querySelectorAll('.team-card'));
          removeDashboardCardClickListener();
          addCarouselCardClickListener();
          addPanEventListenerToSlider();
        }
      }
    });

    sliderClose.addEventListener('click', function () {
      if (teamCardSlider && teamCardSlider.destroy) {
        flip.read(teamCards);

        hideElement(sliderControls);
        teamCardSlider.destroy();
        teamCards = Array.from(document.querySelectorAll('.team-card'));
        updateTeamCardGridPositions();
        hideElement(sliderClose);
        addDashboardCardClickListener();
        removeCarouselCardClickListener();

        flip.remove(getNotActiveCards());
        flip.play(getActiveCards());
      }
    });

    addSliderControlsClickListener();

    function getActiveCards() {
      return teamCards.filter((card) =>
        activeTypes.some((activeType) => card.classList.contains(activeType)),
      );
    }

    function getNotActiveCards() {
      return teamCards.filter(
        (card) => !activeTypes.some((activeType) => card.classList.contains(activeType)),
      );
    }

    function getActiveCardIndexes() {
      return teamCards
        .map((card, index) =>
          activeTypes.some((activeType) => card.classList.contains(activeType)) ? index : null,
        )
        .filter((cardIndex) => cardIndex !== null);
    }

    function showElement(element) {
      gsap.fromTo(
        element,
        { opacity: 0 },
        { opacity: 1, duration: 0.5, visibility: 'visible', ease: 'ease-in-out' },
      );
    }

    function hideElement(element) {
      gsap.fromTo(
        element,
        { opacity: 1 },
        {
          opacity: 0,
          duration: 0.5,
          ease: 'ease-in-out',
          onComplete: () => element.style.setProperty('visibility', 'hidden'),
        },
      );
    }

    function addDashboardCardClickListener() {
      teamCards.forEach(function (card, index) {
        card.addEventListener('click', function (e) {
          handleDashboardCardClick(e, index);
        });
      });
    }

    function addCarouselCardClickListener() {
      teamCards.forEach(function (card, index) {
        card.querySelector('.team-card-flip').addEventListener('click', handleCarouselCardClick);
      });
    }

    function removeDashboardCardClickListener() {
      teamCards.forEach(function (card) {
        card.removeEventListener('click', handleDashboardCardClick);
      });
    }

    function removeCarouselCardClickListener() {
      teamCards.forEach(function (card) {
        card.querySelector('.team-card-flip').classList.remove('.flipped');
        card.querySelector('.team-card-flip').removeEventListener('click', handleCarouselCardClick);
      });
    }

    function handleDashboardCardClick(e, currentIndex) {
      if (window.innerWidth >= 768) {
        flip.read(teamCards);
        if (!teamCardSlider || teamCardSlider.destroy === null) {
          updateCardsZindex(currentIndex);
          teamCardSlider = tns({ ...teamCardSliderOptions, startIndex: currentIndex });
          teamCards = Array.from(document.querySelectorAll('.team-card'));
          addPanEventListenerToSlider();
          addCarouselCardClickListener();
          sliderControls = document.querySelector('.team-slider-controls');
          addSliderControlsClickListener();
          showElement(sliderClose);
          showElement(sliderControls);
          teamCardSlider.events.on('indexChanged', handleIndexHasChanged);
        }
        flip.play(getActiveCards());
        flip.reset(teamCards);
      }
    }

    function handleCarouselCardClick() {
      this.classList.toggle('flipped');
    }

    function updateCardsZindex(currentIndex = 0) {
      teamCards.forEach((card, index) => {
        const zIndex =
          teamCards.length - ((index - currentIndex + teamCards.length) % teamCards.length);

        card.style.zIndex = zIndex;
      });
    }

    function animateCard(card, duration) {
      gsap.to(card, {
        duration,
        ease: 'power0',
        motionPath: { path: '#motion-path', align: 'self', alignOrigin: [0.5, 0.5] },
      });
    }

    function handleIndexHasChanged(info, eventName) {
      // console.log('start =====================');
      let { index: currentIndex, indexCached, slideCount: nbItems } = info;
      let nextIndex;

      if (currentIndex === indexCached) {
        teamCardSlider.goTo(indexCached === 0 ? 'prev' : 'next');
        return;
      }

      if (
        teamActiveCardsIndexes.length < nbItems &&
        ((teamActiveCardsIndexes.indexOf(indexCached) === -1 &&
          teamActiveCardsIndexes.indexOf(currentIndex) !== -1) ||
          (teamActiveCardsIndexes.indexOf(indexCached) !== -1 &&
            teamActiveCardsIndexes.indexOf(currentIndex) !== -1))
      ) {
        // console.table({ title: 'Go', sliderDirection, indexCached, nextIndex: currentIndex });
      } else {
        nextIndex = currentIndex;
        // console.table({ title: 'Go', sliderDirection, indexCached, nextIndex: currentIndex });
      }

      while (nextIndex !== undefined && teamActiveCardsIndexes.indexOf(nextIndex) === -1) {
        if (sliderDirection === 'next') {
          nextIndex = (nextIndex + 1) % nbItems;
          // console.log(nextIndex);
        } else {
          if (nextIndex === 0) {
            nextIndex = nbItems - 1;
          } else {
            nextIndex--;
          }
        }
      }

      if (nextIndex !== undefined && nextIndex !== currentIndex) {
        // console.table({ title: 'Jump to next active', sliderDirection, indexCached, nextIndex });
        // console.log('end =====================');
        teamCardSlider.goTo(nextIndex);
        return;
      }

      let timeout;
      info.slideItems[indexCached].querySelector('.team-card-flip').classList.remove('flipped');

      if (sliderDirection === 'next') {
        animateCard(info.slideItems[indexCached], 1);
        timeout = 700;
      } else if (sliderDirection === 'prev') {
        animateCard(info.slideItems[currentIndex], 0.5);
        timeout = 350;
      }
      setTimeout(() => updateCardsZindex(currentIndex), timeout);

      // console.table({ title: 'Go to ' + sliderDirection, indexCached, nextIndex: currentIndex });

      // console.log('end =====================');
    }

    function addPanEventListenerToSlider() {
      const mc = new Hammer(document.querySelector('.tns-outer'));
      mc.on('panleft panright', function (ev) {
        sliderDirection = ev.type === 'panleft' ? 'next' : 'prev';
      });
    }

    function addSliderControlsClickListener() {
      Array.from(sliderControls.children).forEach((control) => {
        control.addEventListener('click', (e) => {
          sliderDirection = control.getAttribute('data-controls');
        });
      });
    }

    function getSliderDirection(nbItems, currentIndex, previousIndex) {
      const delta = currentIndex - previousIndex;

      if (delta < 0) {
        if (previousIndex - delta > nbItems - 1 && delta !== -1) {
          return 'next';
        }
        return 'prev';
      } else {
        if (previousIndex + delta >= nbItems - 1 && delta !== 1) {
          return 'prev';
        }
        return 'next';
      }
    }

    function updateTeamCardGridPositions() {
      let row = 1;
      let index = 0;
      let nthChild = 0;

      teamCards.forEach((card) => {
        if (activeTypes.some((activeType) => card.classList.contains(activeType))) {
          card.style.setProperty('--column', (index % 3) + 1);
          card.style.setProperty('--row', 3 * nthChild + 2 === index + 1 ? row + 1 : row);
          if (index % 3 === 2) {
            row += 2;
          }
          if (3 * nthChild + 2 === index + 1) {
            nthChild++;
          }
          index++;
        } else {
          card.style.setProperty('--column', 1);
          card.style.setProperty('--row', 1);
        }
      });
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};

class Flip {
  constructor() {
    this.duration = 500;
    this.positions = {};
  }

  read(elements) {
    elements.forEach((element) => {
      const id = element.getAttribute('data-flip-id');
      this.positions[id] = element.getBoundingClientRect();
    });
  }

  play(elements) {
    elements.forEach((element) => {
      const id = element.getAttribute('data-flip-id');
      const newPosition = element.getBoundingClientRect();
      const oldPosition = this.positions[id];

      const deltaX = oldPosition.x - newPosition.x;
      const deltaY = oldPosition.y - newPosition.y;
      const deltaW = oldPosition.width / newPosition.width;
      const deltaH = oldPosition.height / newPosition.height;

      element.style.removeProperty('visibility');

      element.animate(
        [
          {
            transform: `translate(${deltaX}px, ${deltaY}px) scale(${deltaW}, ${deltaH})`,
          },
          {
            transform: `none`,
            opacity: 1,
          },
        ],
        { duration: this.duration, fill: 'both', easing: 'ease-in-out' },
      );
    });
  }

  remove(elements, callback) {
    elements.forEach((element) => {
      const id = element.getAttribute('data-flip-id');
      const newPosition = element.getBoundingClientRect();
      const oldPosition = this.positions[id];
      this.positions[id] = newPosition;

      const deltaX = oldPosition.x - newPosition.x;
      const deltaY = oldPosition.y - newPosition.y;

      element.animate(
        [
          {
            transform: `translate(${deltaX}px, ${deltaY}px)`,
            opacity: 1,
          },
          {
            transform: `none`,
            opacity: 0,
          },
        ],
        { duration: this.duration, fill: 'both', easing: 'ease-in-out' },
      );

      Promise.all(element.getAnimations().map((anim) => anim.finished)).then(() => {
        element.style.visibility = 'hidden';
      });
    });
  }

  reset(elements) {
    elements.forEach((element) => {
      Promise.all(
        element
          .getAnimations()
          .filter((anim) => !(anim instanceof CSSTransition))
          .map((anim) => anim.finished),
      ).then(() => {
        element.getAnimations().map((anim) => anim.cancel());
      });
    });
  }
}
